import {
  SortAscendingIcon,
  SortDescendingIcon,
} from '@heroicons/react/outline';
import { useSortBy, useTable } from 'react-table';

/**
 * Create heatmap based on the data and columns passed
 * Pass only MEMOIZED values
 * @param {{data:any[], columns:any[],sortBy?:{id:string, order:"asc" | "desc"}}} param0
 * @returns
 */
export default function RetentionHeatmap({
  data,
  columns,
  sortBy = { id: 'cohort_name', order: 'asc' },
}) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        initialState: {
          sortBy: [{ id: sortBy.id, desc: sortBy.order === 'desc' }],
        },
      },
      useSortBy
    );

  return (
    <table
      {...getTableProps()}
      className="w-full mt-1 table-auto text-segments-13px"
    >
      <thead className="border-b border-black">
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
                {...column.getHeaderProps([
                  {
                    className:
                      // @ts-ignore
                      column.className +
                      ' first:bg-segments-lighter-gray first:sticky first:left-0',
                  },
                  // @ts-ignore
                  column.getSortByToggleProps(),
                ])}
              >
                {column.isSorted ? (
                  <div className={`flex items-end justify-center `}>
                    {column.render('Header')}

                    {column.isSortedDesc ? (
                      <SortDescendingIcon className="w-4 h-4 ml-1" />
                    ) : (
                      <SortAscendingIcon className="w-4 h-4 ml-1" />
                    )}
                  </div>
                ) : (
                  <>{column.render('Header')}</>
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()} className="text-base">
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className="border-b hover:bg-segments-accent-green-3"
            >
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className="p-0 first:sticky first:left-0 first:bg-segments-lighter-gray"
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
